export enum ShapeFilterType {
  MY = "my",
  SHARED = "shared",
}

